import {
  MAutocomplete,
  MButton,
  ResponsiveFormContainer,
} from "@app/components";
import { Box, Modal } from "@mui/material";
import React, { useEffect } from "react";
import { FormProvider, useFormContext } from "react-hook-form";
import { usePrintTag } from "../../utils/usePrintTag";

const styleModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50%",
  maxHeight: "80%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  px: 4,
  py: 2,
  overflowY: "auto",
};
interface PrintLabelProps {
  handleClose: () => void;
  dialogData: any;
}

const TAG_OPTIONS = [
  { label: "Etiqueta 1", value: "tag1" },
  { label: "Etiqueta 2", value: "tag2" },
];

const PrintLabel = ({ handleClose, dialogData }: PrintLabelProps) => {
  const { loadingTag } = usePrintTag();
  const form = useFormContext();
  useEffect(() => {
    form.register("labelType");
    form.setValue("labelType", TAG_OPTIONS[0]);
  }, []);

  const submit = async (data) => {
    dialogData.handleConfirm(data.labelType);
  };

  return (
    <Modal
      open={!!dialogData?.active}
      onClose={handleClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box sx={{ ...styleModal }}>
        <FormProvider {...form}>
          <form onSubmit={form.handleSubmit(submit)}>
            <ResponsiveFormContainer columns={1} padding={2}>
              <MAutocomplete
                name="labelType"
                options={TAG_OPTIONS}
                label="Seleccione reserva"
                getOptionLabel={(option) => option.label || ""}
                validation={{ required: "La etiqueta es requerida" }}
              />
            </ResponsiveFormContainer>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                marginTop: 2,
                gap: 2,
              }}
            >
              <MButton
                text="Guardar"
                type="submit"
                variant="contained"
                disabled={loadingTag}
              />
              <MButton
                onClick={handleClose}
                text="Cerrar"
                variant="outlined"
                disabled={loadingTag}
              />
            </Box>
          </form>
        </FormProvider>
      </Box>
    </Modal>
  );
};

export default PrintLabel;
